// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__Vf7Su","tabs__tab":"styles_tabs__tab__TX4-1","active":"styles_active__T-CBq"};